import { ReactNode } from "react";

import { AppLayout } from "shared/Layout";
import { LegalContent } from "shared/LegalContent";
import { fetchSettings } from "shared/SettingsProvider/settings.helper";
import { CACHE_ONE_WEEK } from "utils/config.utils";
import { fetchPages } from "utils/fetch-page.utilts";
import { withApp } from "utils/with-app.utils";
import { fetchTranslations, useI18n } from "utils/with-i18n.utils";
import { fetchSEO, withSeo } from "utils/with-seo.utils";

type CGUPageProps = { cgu: string };

const CGUPage = ({ cgu }: CGUPageProps) => {
  const i18n = useI18n();

  return (
    <LegalContent
      content={cgu}
      title={i18n.t("cgu.title")}
      lastUpdate={i18n.t("cgu.lastUpdate")}
    />
  );
};

CGUPage.getLayout = (page: ReactNode, pageProps: any) => (
  <AppLayout {...pageProps}>{page}</AppLayout>
);

export async function getStaticProps() {
  const [cgu] = await fetchPages("cgu");
  const translations = await fetchTranslations("legal");

  const seo = await fetchSEO("cgu");

  return {
    props: {
      cgu: cgu.content,
      translations,
      seo,
      settings: await fetchSettings(),
    },
    revalidate: CACHE_ONE_WEEK,
  };
}

export default withApp(CGUPage, [withSeo]);
